import {
  FormControlLabel,
  Switch as MuiSwitch,
  SwitchProps,
  Typography,
  styled,
} from '@mui/material';
import { FC } from 'react';

const SwitchLabel = styled(FormControlLabel)({
  margin: 0,
});

type Props = Pick<SwitchProps, 'color' | 'edge'> & {
  label?: string;
  checked?: boolean;
  name?: string;
  onChange?: (checked: boolean) => void;
  disabled?: boolean;
};

const Switch: FC<Props> = ({
  label,
  checked,
  name,
  onChange,
  color = 'secondary',
  disabled,
  edge,
}) => {
  const labelVariant = checked ? 'h6' : 'body2';
  const labelColor = checked ? 'grey.900' : 'grey.500';

  return (
    <SwitchLabel
      disabled={disabled}
      control={
        <MuiSwitch
          size="medium"
          color={color}
          checked={!!checked}
          name={name}
          onChange={(_, checked) => {
            onChange?.(checked);
          }}
          disabled={disabled}
          edge={edge}
        />
      }
      label={
        <Typography variant={labelVariant} color={labelColor}>
          {label}
        </Typography>
      }
      labelPlacement="start"
    />
  );
};

export default Switch;
